import React from 'react';
import { FiSun, FiMoon, FiMonitor } from 'react-icons/fi';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * Compact icon-only toggle that cycles light → dark → system → light.
 * The icon shown reflects the current SETTING (not the resolved value):
 *   - sun  → user picked 'light'
 *   - moon → user picked 'dark'
 *   - monitor → user picked 'system' (icon doesn't change with OS pref)
 *
 * Sized and styled to fit alongside other top-nav icon buttons. Tooltip via
 * the native `title` attribute keeps zero dependencies; we can swap to an
 * antd Tooltip later if the rest of the nav uses one.
 */
export default function ThemeToggle({ className = '' }) {
  const { theme, cycleTheme } = useTheme();

  const Icon = theme === 'dark' ? FiMoon : theme === 'system' ? FiMonitor : FiSun;
  const label =
    theme === 'dark'
      ? 'Theme: dark — click for system'
      : theme === 'system'
        ? 'Theme: system — click for light'
        : 'Theme: light — click for dark';

  return (
    <button
      type="button"
      onClick={cycleTheme}
      title={label}
      aria-label={label}
      className={`inline-flex items-center justify-center w-9 h-9 rounded-lg text-fg-muted hover:bg-canvas-elevated hover:text-fg-default transition-colors ${className}`}
    >
      <Icon className="w-[18px] h-[18px]" />
    </button>
  );
}
